import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Button from "../components/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const CornerPageLinks = ({ links }) => {
  return (
    <div className="block-buttongroup">
      {links?.map((link, i) => (
        <Link
          key={i}
          to={link?.uri
            .replace("localhost:8000", "")
            .replace("enkle.re/MEV-DEV", "")
            .replace("https://", "")
            .replace("http://", "")}
          className="block-buttongroup-link"
        >
          <Button variant="primary" hasIcon={true}>
            {link?.title}
            <FontAwesomeIcon
              icon={faArrowRight}
              style={{ paddingLeft: "1rem" }}
            />
          </Button>
        </Link>
      ))}
    </div>
  );
};

CornerPageLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({ uri: PropTypes.string, title: PropTypes.string })
  ),
};

CornerPageLinks.defaultProps = {
  links: undefined,
};

export default CornerPageLinks;
